import { render, staticRenderFns } from "./page010.vue?vue&type=template&id=0788f05a&scoped=true&"
import script from "./page010.vue?vue&type=script&lang=js&"
export * from "./page010.vue?vue&type=script&lang=js&"
import style0 from "./page010.vue?vue&type=style&index=0&id=0788f05a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0788f05a",
  null
  
)

export default component.exports